(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-preorder"] && !Shopify.designMode) return;
  try {
    (function () {
    var notice       = document.getElementById('preorder-notice');
    var deliveryText = document.getElementById('preorder-delivery-text');
    if (!notice) return;

    var meta = window.__preorderMeta || {};
    var data = window.__preorderData || {};

    function getDeliveryLabel(weeks) {
      if (!weeks || weeks <= 0) return meta.fallbackMessage || 'Ships when stock is available';
      return 'Estimated to ship within <strong>' + weeks + '</strong> week' + (weeks === 1 ? '' : 's');
    }

    function getCartTextEl() {
      var btn = document.querySelector('button[name="add"]');
      return btn ? btn.querySelector('.add-to-cart-text__content span span') : null;
    }

    function setButtonLabel(isPreorder) {
      var el = getCartTextEl();
      if (!el) return;
      if (!el.dataset.originalLabel) el.dataset.originalLabel = el.textContent.trim();
      el.textContent = isPreorder ? (meta.buttonLabel || 'Preorder') : el.dataset.originalLabel;
    }

    function updateAll(variantId) {
      var v = data[variantId];
      var shouldShow =
        v &&
        meta.enabled === true &&
        v.inventoryManagement === 'shopify' &&
        v.inventoryPolicy     === 'continue' &&
        v.inventoryQuantity   <= 0;

      if (shouldShow) {
        notice.removeAttribute('hidden');
        if (deliveryText) deliveryText.innerHTML = getDeliveryLabel(meta.deliveryWeeks);
      } else {
        notice.setAttribute('hidden', '');
      }

      setButtonLabel(shouldShow);
    }

    // Set button label on page load using value passed via __preorderMeta
    setButtonLabel(meta.isPreorderOnLoad);

    document.addEventListener('variant:update', function (e) {
      var variant = e.detail && e.detail.resource;
      if (variant) updateAll(variant.id);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
